import katex from 'katex';

export default function(options = {}) {
  let inlineOptions = {...options}
  inlineOptions.displayMode = false
  let blockOptions = {...options}
  blockOptions.displayMode = true
  return {
    extensions: [
      inlineKatex(inlineOptions),
      blockKatex(blockOptions)
    ]
  };
}

function inlineKatex(options) {
  return {
    name: 'inlineKatex',
    level: 'inline',
    start(src) { return src.indexOf('$'); },
    tokenizer(src, tokens) {
      const match = src.match(/^\$([^$\n]+?)\$/);
      if (match) {
        return {
          type: 'inlineKatex',
          raw: match[0],
          text: match[1].trim()
        };
      }
      const match2 = src.match(/^\\\((.*?)\\\)/);
      if (match2) {
        return {
          type: 'inlineKatex',
          raw: match2[0],
          text: match2[1].trim()
        };
      }
    },
    renderer(token) {
      return katex.renderToString(token.text, options);
    }
  };
}

function blockKatex(options) {
  return {
    name: 'blockKatex',
    level: 'block',
    start(src) { return src.indexOf('$$'); },
    tokenizer(src, tokens) {
      const match = src.match(/^\$\$+([^$]+?)\$\$+/);
      if (match) {
        return {
          type: 'blockKatex',
          raw: match[0],
          text: match[1].trim()
        };
      }
      const match2 = src.match(/^\\\[([\s\S]+?)\\\]/);
      if (match2) {
        return {
          type: 'blockKatex',
          raw: match2[0],
          text: match2[1].trim()
        };
      }
    },
    renderer(token) {
      return `<p>${katex.renderToString(token.text, options)}</p>`;
    }
  };
}
